

import React from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { changeUserPassword } from "../../../redux/action/auth/authAction";
import { useDispatch } from "react-redux";
import {
    Row,
    Col,
    Typography,
   
    Checkbox,
  } from "antd";
import InputBox from "../../../components/common/input";
import Title from "antd/es/skeleton/Title";

const ResetPasswordModal = ({ visible, resetModel, onCancel, setResetModel, userId }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch()




  const handleSubmit = (values) => {
    const data = {...values, user_id: userId }
    // form.resetFields();
    try {
      dispatch(
        changeUserPassword(data, () => {
          form.resetFields();
          setResetModel(false)
        })
      );
    } catch (error) {
      message.error("OTP verification failed. Please try again.");
    }
  };

  return (
    <Modal
      title={`Password Reset for Account: ${resetModel?.userName}`}
      open={visible}
      onCancel={() => {
        setResetModel(false);
        form.resetFields();
      }}
      footer={null}
    >
      {/* <Form form={form} layout="vertical">
        <Form.Item
          label="New Password"
          name="newPassword"
          rules={[
            { required: true, message: "Please input your new password!" },
            {
            //   pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
              message:
                "Password must be at least 8 characters long, with uppercase, lowercase, and a number.",
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: "Please confirm your password!" },
            // ({ getFieldValue }) => ({
            //   validator(_, value) {
            //     if (!value || getFieldValue("newPassword") === value) {
            //       return Promise.resolve();
            //     }
            //     return Promise.reject(
            //       new Error("Passwords do not match!")
            //     );
            //   },
            // }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", }}>
            <Button style={{ height: "50px", width: "100px"}} onClick={onCancel}>Cancel</Button>
            <Button type="primary" onClick={handleSubmit}>
              Reset Password
            </Button>
          </div>
        </Form.Item>
      </Form> */}
       <div className="changePassword">
        <Row gutter={16} className="signin-row">
          <Col xs={24} sm={24}>
            <div className="">
              <div className="leftContainer">
                <Title level={2}>Change Password</Title>
               
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="signin-form"
                >
                 

                  <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a new password!",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      },
                    ]}
                  >
                    <InputBox
                      size="large"
                      placeholder="New Password"
                      // className="custom-input"
                      type="password"
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirmPassword"
                    label="Confirm New Password"
                    dependencies={["newPassword"]}
                    rules={[
                      {
                        required: true,
                        message: "Please confirm your password!",
                      },
                      {
                        pattern:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("newPassword") === value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Passwords do not match!")
                          );
                        },
                      }),
                    ]}
                  >
                    <InputBox
                      size="large"
                      placeholder="Confirm New Password"
                      // className="custom-input"
                      type="password"
                    />
                  </Form.Item>

                  {/* <Form.Item
                    name="terms"
                    valuePropName="checked"
                    rules={[
                      {
                        required: true,
                        message: "You must accept the terms and conditions!",
                      },
                    ]}
                  >
                    <Checkbox>I accept the Terms and Conditions</Checkbox>
                  </Form.Item> */}

                  <Form.Item>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", }}>
            <Button style={{ height: "50px", width: "100px"}} onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Reset Password
            </Button>
          </div>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;




// import React from "react";

// const ResetPasswordModal = ({ visible, onCancel, setResetModel,  userId }) => {
//     const [newPassword, setNewPassword] = React.useState('');
//     const [confirmPassword, setConfirmPassword] = React.useState('');
//     const [passwordError, setPasswordError] = React.useState('');
  
//     React.useEffect(() => {
//         if (!visible) {
//             setNewPassword('');
//             setConfirmPassword('');
//             setPasswordError('');
//         }
//     }, [visible]);
  
//     const handleSubmit = () => {
//         setPasswordError(''); // Clear previous errors
//         setResetModel(false)
  
//         if (!newPassword || !confirmPassword) {
//             setPasswordError("All fields are required.");
//             return;
//         }
  
//         if (newPassword !== confirmPassword) {
//             setPasswordError("Passwords do not match.");
//             return;
//         }
  
//         // Basic password validation: at least 8 characters, one uppercase, one lowercase, one number
//         // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
//         // if (!passwordRegex.test(newPassword)) {
//         //     setPasswordError("Password must be at least 8 characters long, contain one uppercase letter, one lowercase letter, and one number.");
//         //     return;
//         // }
  
//         onSubmit(newPassword, confirmPassword);
//     };

//     const onSubmit = (password, confirmPassword) => {
//         console.log(password, "dsmllddfg")
//     }
  
//     if (!visible) return null;
  
//     return (
//         <div style={{
//             position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
//             backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
//             justifyContent: 'center', alignItems: 'center', zIndex: 1000
//         }}>
//             <div style={{
//                 backgroundColor: 'white', padding: 20, borderRadius: 8,
//                 width: 400, maxWidth: '90%', boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
//             }}>
//                 <h3>Reset Password for User ID: {userId}</h3>
//                 <div style={{ marginBottom: 15 }}>
//                     <label style={{ display: 'block', marginBottom: 5 }}>New Password:</label>
//                     <input
//                         type="password"
//                         value={newPassword}
//                         onChange={(e) => setNewPassword(e.target.value)}
//                         style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//                     />
//                 </div>
//                 <div style={{ marginBottom: 15 }}>
//                     <label style={{ display: 'block', marginBottom: 5 }}>Confirm Password:</label>
//                     <input
//                         type="password"
//                         value={confirmPassword}
//                         onChange={(e) => setConfirmPassword(e.target.value)}
//                         style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
//                     />
//                 </div>
//                 {passwordError && (
//                     <p style={{ color: 'red', marginBottom: 15 }}>{passwordError}</p>
//                 )}
//                 <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
//                     <button
//                         onClick={onCancel}
//                         style={{ padding: '8px 15px', borderRadius: 4, border: '1px solid #ccc', background: 'white', cursor: 'pointer' }}
//                     >
//                         Cancel
//                     </button>
//                     <button
//                         onClick={handleSubmit}
//                         style={{ padding: '8px 15px', borderRadius: 4, border: 'none', background: '#45ae51', color: 'white', cursor: 'pointer' }}
//                     >
//                         Reset Password
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
//   };

//   export default ResetPasswordModal
